import { ContentResponse } from './content.interface';

export interface MarketingPlatform {
  contentId: number;
  contentType: string;
  htmlTags: string;
  tags: string;
  internalNote: string;
  keywords: string;
  platform: string;
  musicFileLicense?: string;
  publishedStatus: string;
  publishedDate: string;
  publisher: string;
  publishingLink: string;
  scheduledDate: string;
  text: string;
  title: string;
  thumbnail: string;
  timezone?: string;
  privacyStatus: 'private' | 'public';
}
export interface AddMarketingPlatformProps {
  platform: string;
  thumbnail?: File | string | null;
  musicFileLicense?: File | string | null;
  scheduledDate: string;
  timezone: string;
  title: string;
  htmlTags: string;
  text: string;
  publisher: string;
  keywords: string;
  internalNote: string;
  contentFormat: string;
  tags: string;
}

export const MarketingPlatFormFileDefaultValue: AddMarketingPlatformProps = {
  platform: '',
  thumbnail: undefined,
  musicFileLicense: undefined,
  scheduledDate: '',
  timezone: '',
  title: '',
  htmlTags: '',
  text: '',
  internalNote: '',
  publisher: '',
  keywords: '',
  contentFormat: 'Regular',
  tags: '',
};

export interface StatusPropType {
  id: number;
  name: string;
  value: string;
}

export interface PostQueryParams {
  statuses?: string[];
  startDate?: Date | string;
  endDate?: Date | string;
  perPage: number;
  page: number;
}

export interface PostReqParams {
  title: string;
  keywords: string;
  text: string;
  scheduledDate?: string;
  timezone?: string;
  privacyStatus: string;
  platforms: string[];
  contentType: string;
}

export interface AnalyticsQueryParams {
  platform: string;
  timeRange?: string;
}

export interface PostAnalyticsProps {
  id: number;
  platform: string;
  title: string;
  publishedDate: string;
  reach: number;
  engagementRate: number;
  clicks: number;
  scheduledAt: string;
  uploadStatus: string;
  publishedAt: string;
}

export interface PostStatsProps {
  label: string;
  value: string;
  change: string;
  trend: string;
  icon: any;
}

export interface MarketingListParams {
  perPage: number;
  page: number;
  type?: string;
  scheduledPost?: boolean;
  assetContentType?: { name: string };
}

export interface PostResponse {
  list: ContentResponse[];
  totalCount: number;
  currentPag: number;
  perPage: number;
  totalPages: number;
}

export type Platform = 'Instagram' | 'Facebook' | 'LinkedIn' | 'YouTube' | 'Twitter';
export type CalendarView = 'india' | 'us' | 'combined';

export interface ScheduledPost {
  id: string;
  date: string;
  time: string;
  title: string;
  platform: Platform[];
  status: 'scheduled' | 'draft' | 'published';
  mediaPreview?: string;
  videoUrl?: string;
}

export interface EventItem {
  name: string;
  type: string;
  color: string;
}
